import { Stack, Typography, styled } from "@mui/material";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
// import Regeneratepopup from "../MailComponent/Regenratepopup";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { useDispatch, useSelector } from "react-redux";
import WelcomeNameContainer from "../LaunchComponent/WelcomeNameContainer";
import { fetchCampaignsData, handleCampainIDSelection, resetSubmissionButton } from "../Redux/Mailer";
import { handleGenerateRecognition, handleRecognitionLoading } from "../Redux/Recognition";
import RecognitionDataDisplay from "./recognitionDataDisplay";
import "./recognitionForm.css";
const CustomRadio = styled(Radio)(({
  theme
}) => ({
  "&.Mui-checked": {
    color: "#9c27b0" // Purple for the checked state
  },
  "& .MuiSvgIcon-root": {
    fontSize: "1.5rem" // Custom icon size
  },
  "&:hover": {
    backgroundColor: "rgba(156, 39, 176, 0.08)" // Optional hover effect
  }
}));
const WhiteBorderTextField = styled(TextField)`
 & label.Mui-focused {
  color: #a804ff;
 }
 & .MuiOutlinedInput-root {
  &.Mui-focused fieldset {
   border-color: #a814ff;
   border-width: 1px;
  }
 }
`;
const RecognitionForm = ({
  programList,
  categoryNameRecognition,
  setCategoryNameRecognition,
  mailerChild,
  setMailerChild,
  setMailerParent,
  mailerParent
}) => {
  const [programNameRecognition, setProgramNameRecognition] = useState("");
  const [targAudienceRecognition, setTargAudienceRecognition] = useState("");
  const [keyMsgRecognition, setKeyMsgRecognition] = useState("");
  const [isNameIncludes, setIsNameIncluded] = useState(false);
  const [campaign, setCampaign] = useState(0);
  const campaignList = useSelector(state => state.model.campaignList);
  const mailList = useSelector(state => state.model.mailList);
  const options = campaignList.message !== "No campaign for this user." && campaignList.length > 0 ? campaignList.map(item => ({
    id: item.id,
    name: item.name
  })) : [];
  const [isRecognitionMailGenerationClicked, setIsRecognitionGenerationClicked] = React.useState(false);
  const [isRecognitionNavigatedToForm, setIsRecognitionNavigatedToForm] = useState(false);
  //  const isRecognitionLoaded = useSelector(
  //   (state) => state.Recognition.isRecognitionLoaded
  //  );
  const dispatch = useDispatch();
  const [isRecognitionMailGenerated, setIsRecognitionMailGenerated] = useState("init");
  const handleCampaignID = val => {
    if (val) {
      setCampaign(val.id);
      let campaignID = val.id;
      dispatch(handleCampainIDSelection(campaignID));
      let data = campaignList.filter(val => val.id == campaignID);
      setProgramNameRecognition(data[0].name);
    }
  };
  useEffect(() => {
    dispatch(fetchCampaignsData(categoryNameRecognition));
  }, []);
  const [value, setValue] = React.useState(null);
  const handleChange = event => {
    if (event.target.value == "no") {
      setCampaign(0);
      dispatch(handleCampainIDSelection(0));
    }
    handleRadioChangeReset();
    setValue(event.target.value);
  };
  const today = new Date().toISOString().split("T")[0];
  const handleReset = () => {
    dispatch(resetSubmissionButton());
    setMailerChild("");
    setMailerParent("");
    setCategoryNameRecognition("Program");
    setProgramNameRecognition("");
    setTargAudienceRecognition("");
    setKeyMsgRecognition("");
  };
  const handleRadioChange = e => {
    setValue("");
    handleRadioChangeReset();
    setCategoryNameRecognition(e.target.value);
    dispatch(fetchCampaignsData(e.target.value));
  };
  const handleRadioChangeReset = () => {
    dispatch(resetSubmissionButton());
    setCampaign(0);
    setProgramNameRecognition("");
    setKeyMsgRecognition("");
    setIsRecognitionMailGenerated("init");
    setIsRecognitionNavigatedToForm(false);
  };
  const handleProgramNameChange = currentName => {
    setProgramNameRecognition(currentName);
    // setIsNameIncluded(mailList.includes(currentName));
  };
  const handleRecognitionMailGeneration = () => {
    setIsRecognitionGenerationClicked(true);
    let values = {
      programNameRecognition: programNameRecognition,
      targAudienceRecognition: targAudienceRecognition,
      keyMsgRecognition: keyMsgRecognition,
      currentContent: "",
      sessionID: localStorage.getItem("sessionId"),
      categoryName: categoryNameRecognition
    };
    dispatch(handleGenerateRecognition(values));
  };
  const HtmlTooltip = styled(({
    className,
    ...props
  }) => <Tooltip {...props} classes={{
    popper: className
  }} />)(({
    theme
  }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9"
    }
  }));
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 200
      }
    }
  };
  return <>
   {!isRecognitionMailGenerationClicked ? <Stack>
     <Stack sx={{
        width: "100%"
      }}>
      <WelcomeNameContainer currentComp="Recognition" />
      <Stack spacing={1} className="mail-form-container-stack">
       <div className="mail-form-container">
        <div className="mailer-form-categories-section">
         <label class="mailer-form-categories-container">
          <span className="mailer-form-categories-text">Learning Program</span>
          <input type="radio" checked={categoryNameRecognition === "Program"} value="Program" name="radio-category" onChange={handleRadioChange} />
          <span class="mailer-form-categories-checkmark"></span>
         </label>
         <label class="mailer-form-categories-container">
          <span className="mailer-form-categories-text">Event</span>
          <input type="radio" checked={categoryNameRecognition === "Event"} value="Event" name="radio-category" onChange={handleRadioChange} />
          <span class="mailer-form-categories-checkmark"></span>
         </label>
         <label class="mailer-form-categories-container">
          <span className="mailer-form-categories-text">Microsite/Tool/Platform</span>
          <input type="radio" checked={categoryNameRecognition === "Microsite/Tool/Platform"} value="Microsite/Tool/Platform" name="radio-category" onChange={handleRadioChange} />
          <span class="mailer-form-categories-checkmark"></span>
         </label>
         <label class="mailer-form-categories-container">
          <span className="mailer-form-categories-text">Webinar</span>
          <input type="radio" checked={categoryNameRecognition === "Webinar"} value="Webinar" name="radio-category" onChange={handleRadioChange} />
          <span class="mailer-form-categories-checkmark"></span>
         </label>
        </div>
        <Stack direction={"row"} sx={{
              alignItems: "flex-start"
            }} spacing={2}>
         <Stack direction={"row"} sx={{
                alignItems: "flex-start"
              }} spacing={2}>
          <Stack direction={"column"}>
           <Typography>
            Is this communication part of any campaign?
            <span className="migrated-style-recognitionform-7d0bd7-1">*</span>
           </Typography>
           <Typography>(If yes, select the campaign name)</Typography>
          </Stack>

          <FormControl>
           <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group" value={value} onChange={handleChange} sx={{
                    paddingLeft: "20px"
                  }}>
            <FormControlLabel value="yes" control={<CustomRadio icon={<RadioButtonUncheckedIcon className="migrated-style-recognitionform-7d0bd7-2" />} // Empty circle when unchecked
                    checkedIcon={<CheckCircleOutlineIcon className="migrated-style-recognitionform-7d0bd7-3" />} // Checkmark inside circle when checked
                    />} label="Yes" />
            <FormControlLabel value="no" control={<CustomRadio icon={<RadioButtonUncheckedIcon className="migrated-style-recognitionform-7d0bd7-4" />} // Empty circle when unchecked
                    checkedIcon={<CheckCircleOutlineIcon className="migrated-style-recognitionform-7d0bd7-5" />} // Checkmark inside circle when checked
                    />} label="No" />
           </RadioGroup>
          </FormControl>
         </Stack>
         {value == "yes" && <Stack direction={"row"} sx={{
                alignItems: "center"
              }} spacing={2}>
           <Typography>
            Select the campaign <span className="migrated-style-recognitionform-7d0bd7-6">*</span>
           </Typography>
           <Stack className="mail-form-headers" sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginBottom: "10px",
                  m: 1,
                  width: 200,
                  mt: 3
                }} direction={"row"} spacing={2}>
            {/* <Select value={campaign} onChange={handleCampaignID} MenuProps={MenuProps}>
             {campaignList.message != "No campaign for this user." &&
              campaignList.length > 0 &&
              campaignList.map((item, index) => (
               <MenuItem key={index + 1} value={item.id}>
                {item.name}
               </MenuItem>
              ))}
             </Select> */}
            <Autocomplete value={options.find(option => option.id === campaign) || null} onChange={(event, newValue) => {
                    handleCampaignID(newValue);
                  }} options={options} getOptionLabel={option => option.name || ""} ListboxProps={{
                    style: {
                      maxHeight: "150px",
                      // Fixed height for the dropdown
                      overflowY: "auto" // Enable vertical scrolling
                    }
                  }} renderInput={params => <TextField sx={{
                    "& .MuiOutlinedInput-root": {
                      padding: "2px !important"
                    }
                  }} {...params} variant="outlined" />} filterSelectedOptions={false} />
           </Stack>
          </Stack>}
        </Stack>
        <div className="mail-form-wrap-recognition">
         <div className="mail-form-inner-wrap migrated-style-recognitionform-7d0bd7-7">
          <Stack className="mail-form-headers" sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginBottom: "10px"
                }}>
           <Typography sx={{
                    fontSize: "16px"
                  }}>
            <span>
             Name<span className="migrated-style-recognitionform-7d0bd7-8">*</span>
            </span>
            <HtmlTooltip arrow title={<React.Fragment>
               {categoryNameRecognition == "Program" ? <p> Enter the program name </p> : categoryNameRecognition == "Event" ? <p> Enter the event name</p> : categoryNameRecognition == "Microsite/Tool/Platform" ? <p> Enter the Microsite/Tool/Platform name</p> : <p> Enter the Webinar name</p>}
              </React.Fragment>}>
             <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-recognitionform-7d0bd7-9" />
            </HtmlTooltip>
           </Typography>
           {/* <WhiteBorderTextField
            placeholder={
             categoryNameRecognition == "Program"
              ? "e.g: Java Full Stack"
              : categoryNameRecognition == "Event"
              ? "e.g: Google Cloud Fusion Fest"
              : categoryNameRecognition == "Webinar"
              ? "e.g: Cloud Computing"
              : "e.g: Kortext Platform"
            }
            id="multiline"
            multiline
            minRows={1}
            maxRows={2}
            disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
            InputProps={{
             readOnly: value === "yes" && campaign != 0,
            }}
            value={programNameRecognition}
            InputLabelProps={{ shrink: false }}
            onChange={(event) => {
             handleProgramNameChange(event.target.value);
             setIsRecognitionMailGenerated("init");
            }}
            fullWidth
            /> */}
                  <Autocomplete id="free-solo-demo" freeSolo value={programNameRecognition} onChange={(event, newValue) => {
                    handleProgramNameChange(newValue || ""); // Ensure value updates when selecting a suggestion
                    setIsRecognitionMailGenerated("init");
                  }} onInputChange={(event, newInputValue) => {
                    handleProgramNameChange(newInputValue); // Update state when typing
                  }} disabled={!value || value === "yes"} inputprops={{
                    readOnly: value === "yes"
                  }} options={programList.map(option => option.programname)} renderInput={params => <WhiteBorderTextField {...params} id="multiline" multiline minRows={1} maxRows={2} fullWidth placeholder={categoryNameRecognition === "Program" ? "e.g: Java Full Stack" : categoryNameRecognition === "Event" ? "e.g: ATCI Event" : categoryNameRecognition === "Microsite/Tool/Platform" ? "e.g: ATCI Learning" : "e.g: ATCI Webinar"} disabled={!value || value === "yes" && campaign === 0} />} />
          </Stack>
          <Stack className="mail-form-headers" sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginBottom: "10px"
                }}>
           <Typography sx={{
                    fontWeight: "400",
                    fontSize: "16px"
                  }}>
            {/* Key Highlights <span style={{ color: "lightgray" }}></span> */}
            <span>
             Key Message
             <span className="migrated-style-recognitionform-7d0bd7-10">*</span>
            </span>
            <HtmlTooltip arrow title={<React.Fragment>
               {categoryNameRecognition == "Program" ? <p>
                 Provide recognition details (e.g., participation, contribution, winning,
                 facilitation, performance).
                </p> : categoryNameRecognition == "Event" ? <p>
                 Provide recognition details (e.g., participation, contribution, winning,
                 performance).
                </p> : categoryNameRecognition == "Webinar" ? <p>
                 Provide recognition details (e.g., participation, contribution, winning,
                 performance).
                </p> : <p>
                 Provide recognition details (e.g., participation, contribution,
                 facilitation, performance).
                </p>}
              </React.Fragment>}>
             <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-recognitionform-7d0bd7-11" />
            </HtmlTooltip>
           </Typography>
           <WhiteBorderTextField
                  //placeholder="Key Highlights"
                  placeholder={categoryNameRecognition == "Program" ? "e.g: Your contribution as a facilitator is highly appreciated. " : categoryNameRecognition == "Event" ? "e.g: Your significant contribution is highly appreciated. " : categoryNameRecognition == "Webinar" ? "Your participation in the webinar is highly appreciated. " : "e.g: Your contribution to the platform launch is highly appreciated. "} id="multiline" multiline minRows={3} disabled={value == null || value == "yes" && campaign == 0 ? true : false} InputLabelProps={{
                    shrink: false
                  }} onChange={event => {
                    setKeyMsgRecognition(event.target.value);
                    setIsRecognitionMailGenerated("init");
                  }} fullWidth
                  //    value={keyPoints}
                  value={keyMsgRecognition} />
          </Stack>
         </div>
        </div>
       </div>
       <div className="btn-container">
        {isRecognitionNavigatedToForm && <button className="reset-btn" onClick={() => {
              setIsRecognitionMailGenerated("generateOutput");
              setIsRecognitionGenerationClicked(true);
            }}>
          Next
         </button>}

        {programNameRecognition == "" || keyMsgRecognition == "" || isRecognitionMailGenerated !== "init" ? <div className="mailer-generate-btn-disable">
          <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"}></img>
          <span>Generate</span>
         </div> : <div className="mailer-generate-btn" onClick={() => {
              handleRecognitionMailGeneration();
              setIsRecognitionMailGenerated("generateOutput");
              dispatch(handleRecognitionLoading());
            }}>
          <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"}></img>
          <span>Generate</span>
         </div>}
       </div>
      </Stack>
     </Stack>
    </Stack> : isRecognitionMailGenerated == "generateOutput" ? <>
     <RecognitionDataDisplay setIsRecognitionGenerationClicked={setIsRecognitionGenerationClicked} categoryNameRecognition={categoryNameRecognition} mailerChild={mailerChild} mailerParent={mailerParent} handleReset={handleReset} setIsRecognitionNavigatedToForm={setIsRecognitionNavigatedToForm} setIsRecognitionMailGenerated={setIsRecognitionMailGenerated} programNameRecognition={programNameRecognition} />
    </> : <></>}
  </>;
};
export default RecognitionForm;
